import { mapActions, mapMutations } from 'vuex'

export default {
  methods: {
    ...mapMutations({
      setSubsectionAnswer: 'education/setSubsectionAnswer',
      setSubsectionTitle: 'education/setSubsectionTitle',
      updateSolvedTasks: 'test/updateSolvedTasks'
    }),
    ...mapActions({
      updateUpdater: 'contentManager/updateUpdater',
      pushToasts: 'toasts/pushToasts'
    }),
    $_subsectionMixin_updateSolved(questions) {
      const answeredQuestions = questions.filter((q) => {
        const aq = this.$cookies.get(q)
        return aq !== null
      })
      this.updateSolvedTasks(answeredQuestions)
      this.pushToasts({
        title: 'Уведомление',
        message: 'Ответ успешно изменен',
        time: 1
      })
    },
    $_subsectionMixin_onTitleChange(event) {
      this.updateUpdater()
      this.setSubsectionTitle(event)
    },
    $_subsectionMixin_onAnswerChange(answer) {
      this.updateUpdater()
      this.setSubsectionAnswer(answer)
    },
    $_subsectionMixin_getAnswerCookies(testId) {
      return this.$cookies.get(this.$cookies.keys().find((k) => k.includes(`test_${testId}_${this.$route.params.subsectionId}`)))
    },
    $_subsectionMixin_getAnswerFromData(test, solvedByStudent) {
      const result = solvedByStudent
        .find((sbs) => Number(sbs[0])
          === test.subSections
            .find((ss) => ss.id === Number(this.$route.params.subsectionId)).task.id)[1]
      return result ? result.answer : null
    }
  }

}
